<template>
  <span v-if="hubspot_link">
    <a
            :href="hubspot_link"
            target="_blank"
            rel="noopener noreferrer"
            title="View in HubSpot"
            class="integration-link-icon"
    >
        <i class="fab fa-hubspot item-icon hubspot_link_icon"></i>
    </a>
  </span>
</template>

<script>
export default {
    name: 'contact-integrations-link-icons',
    props: {
        contact: {
            type: Object,
            required: true
        }
    },
    computed: {
        hubspot_link () {
          return this.contact?.integration_data?.hubspot?.link || null
        }
    }
}
</script>

<style scoped>
.integration-link-icon {
    margin-left: 4px;
    vertical-align: middle;
}
.integration-link-icon i {
    font-size:17px;
    width: 17px;
    height: 17px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.integration-link-icon i.fa-hubspot {
    background-color: #FFF;
    color: #FF7A59;
}
.integration-link-icon i:before {
    display: inline-block;
}
</style>
